// extracted by mini-css-extract-plugin
export default {"main":"login_main__6g4SF","submain":"login_submain__JPDTx","loginP":"login_loginP__3hL68","loginmain":"login_loginmain__pksKT","sidebarMain":"login_sidebarMain__-LzNF"};